export default {
  "content": "<title>Ellipsis Vertical Circle</title><circle cx=\"256\" cy=\"256\" r=\"26\"/><circle cx=\"256\" cy=\"346\" r=\"26\"/><circle cx=\"256\" cy=\"166\" r=\"26\"/><path d=\"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};